import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito experiencia previa en Reiki?',
  a: 'No, el MegaPack está diseñado para principiantes absolutos. Empezamos desde cero con el Nivel 1 y te guiamos paso a paso hasta la Maestría.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después de tu compra recibís un email con el enlace de descarga. Todo el material es digital (PDFs, audios MP3) y podés accederlo desde cualquier dispositivo.'
}, {
  q: '¿Los certificados tienen validez?',
  a: 'Los certificados son personalizables y avalan tu formación en Reiki Usui. Son ideales para presentar en tu espacio de trabajo o consultorio.'
}, {
  q: '¿Puedo hacer el curso a mi ritmo?',
  a: '¡Por supuesto! No hay fechas límite ni horarios. El material es tuyo de por vida y podés avanzar cuando quieras.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si por cualquier motivo no estás satisfecho/a, te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  q: '¿Puedo practicar Reiki a distancia con este material?',
  a: 'Sí, en el Nivel 2 aprendés técnicas de sanación a distancia con los símbolos sagrados. Es una de las partes más poderosas del entrenamiento.'
}, {
  q: '¿Incluye sintonizaciones/iniciaciones?',
  a: 'El material incluye guías detalladas sobre el proceso de sintonización y auto-sintonización, con instrucciones paso a paso para cada nivel.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 bg-dark-bg" data-id="element-75">
      <div className="max-w-3xl mx-auto" data-id="element-76">
        <h2 className="text-4xl font-display font-bold text-white text-center mb-12" data-id="element-77">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-78">
          {FAQS.map((faq, index) => <div key={index} className="bg-dark-surface border-l-4 border-violet-500 rounded-r-lg overflow-hidden" data-id="element-79">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-80">
                <span className="font-bold text-white text-lg pr-4" data-id="element-81">
                  {faq.q}
                </span>
                {openIndex === index ? <Minus className="w-5 h-5 text-violet-400 shrink-0" data-id="element-82" /> : <Plus className="w-5 h-5 text-violet-400 shrink-0" data-id="element-83" />}
              </button>

              <AnimatePresence data-id="element-84">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-85">
                    <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-white/5" data-id="element-86">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}